<template>
  <div class="section section-blockchain" id="blockchain-section" data-background-color="white">
    <div data-aos="fade-right" data-aos-offset="-500" class="img_deco_01">
    </div>
    <div class="container text-center">
      <h3 data-aos="fade-up" data-aos-offset="-500" class="title deco1">{{$t(`Blockchain Features`)}}</h3>
      <div class="space-50"></div>
      <div class="row">
        <div data-aos="fade-right" data-aos-offset="-500" class="col-lg-4">
          <div class="col-lg-12 box-blockchain" style="padding: 5px 5px 0px; min-height: 440px;">
            <img v-lazy="'/img/img_game_04.png'" width="100%" />
            <h5 class="blockchain-title" style="margin-top: -42px;">{{$t(`menu_land`)}}</h5>
            <h5 class="blockchain-desc" style="margin: 50px 30px 0px;  min-height: 150px;">{{$t(`land desc`)}}</h5>            
          </div>
          <!-- <div class="col-lg-12 box-blockchain" style="padding: 5px; min-height: 80px;">
            <router-link
              class="btn btn-main2 btn-wide btn-upper btn-lg"
              to="/land"
            >
              {{$t('detail')}}
            </router-link>
          </div>           -->
        </div>
        <div data-aos="fade-up" data-aos-offset="-500" class="col-lg-4">
          <div class="col-lg-12 box-blockchain" style="padding: 5px 5px 0px;">
            <img v-lazy="'/img/img_game_05.png'" width="100%" />
            <h5 class="blockchain-title" style="margin-top: -42px;">{{$t(`menu_governance`)}}</h5>
            <h5 class="blockchain-desc" style="margin: 50px 30px 0px;  min-height: 150px;">{{$t(`gorvernance desc`)}}</h5>
          </div> 
          <!-- <div class="col-lg-12 box-blockchain" style="padding: 5px; min-height: 80px;">
            <router-link
              class="btn btn-main2 btn-wide btn-upper btn-lg"
              to="/governance"
            >
              {{$t('detail')}}
            </router-link>
          </div>   -->
        </div>
        <div data-aos="fade-left" data-aos-offset="-500" class="col-lg-4">
          <div class="col-lg-12 box-blockchain" style="padding: 5px 5px 0px;">
            <img v-lazy="'/img/img_game_06.png'" width="100%" />
            <h5 class="blockchain-title" style="margin-top: -42px;">{{$t(`menu_skin`)}}</h5>
            <h5 class="blockchain-desc" style="margin: 50px 30px 0px;  min-height: 150px;">{{$t(`skin desc`)}}</h5>
          </div> 
          <!-- <div class="col-lg-12 box-blockchain" style="padding: 5px; min-height: 80px;">
            <router-link
              class="btn btn-main2 btn-wide btn-upper btn-lg"
              to="/skin"
            >
              {{$t('detail')}}
            </router-link>
          </div>   -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style></style>
